import { Checkbox, Space } from "antd";

const CalendarFilters = ({ filters, onChange }) => {
  const handleChange = (key) => (e) => {
    onChange({
      ...filters,
      [key]: e.target.checked,
    });
  };

  return (
    <div className="mb-4 p-3 bg-gray-50 rounded-lg">
      <span className="font-semibold text-sm mr-4">Mostrar:</span>
      <Space size="large">
        <Checkbox
          checked={filters.showGroups}
          onChange={handleChange("showGroups")}
        >
          <span className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full bg-blue-500"></span>
            Grupos
          </span>
        </Checkbox>
        <Checkbox
          checked={filters.showExcursions}
          onChange={handleChange("showExcursions")}
        >
          <span className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full bg-green-500"></span>
            Excursiones
          </span>
        </Checkbox>
        <Checkbox
          checked={filters.showTasks}
          onChange={handleChange("showTasks")}
        >
          <span className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full bg-purple-500"></span>
            Tareas
          </span>
        </Checkbox>
      </Space>
    </div>
  );
};

export default CalendarFilters;
